import { useEffect, useState } from "react";
import { CheckCircle2 } from "lucide-react";
import Sheet from "./Sheet";
import { computePrice, nextCycleAddons } from "../pricing";
import { fmtMoney } from "../usagePeriods";

const MONTH_OPTIONS = [1, 3, 6, 12];

/**
 * Pago en dos taps: se abre ya prellenado (1 mes, monto calculado del plan) y solo
 * hay que confirmar. Meses, folio y vigencia se pueden ajustar antes.
 */
export default function QuickPaySheet({ client, open, side, status, onClose, onConfirm }) {
  const [months, setMonths] = useState(1);
  const [reference, setReference] = useState("");
  const [expiresAt, setExpiresAt] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open) { setMonths(1); setReference(""); setExpiresAt(""); setBusy(false); }
  }, [open, client?.id]);

  if (!client) return null;
  // Lo que se cobra es lo que queda vigente con este pago (add-ons programados).
  const monthly = computePrice(client.subscription?.seats, nextCycleAddons(client.subscription));
  const total = monthly * months;

  const confirm = async () => {
    setBusy(true);
    const ok = await onConfirm(client, { months, reference, expiresAt });
    setBusy(false);
    if (ok) onClose();
  };

  return (
    <Sheet
      open={open}
      onClose={onClose}
      side={side}
      title={`Registrar pago · ${client.business?.name}`}
      subtitle={status?.relative || status?.label}
      footer={
        <button type="button" className="sa-btn sa-btn-primary sa-btn-block" onClick={confirm} disabled={busy}>
          <CheckCircle2 size={16} /> {busy ? "Registrando…" : `Confirmar ${fmtMoney(total)} MXN`}
        </button>
      }
    >
      <div className="sa-form">
        <div className="sa-field">
          <span>Meses</span>
          <div className="sa-segment" role="radiogroup">
            {MONTH_OPTIONS.map((m) => (
              <button key={m} type="button" role="radio" aria-checked={months === m} className={`sa-segment-btn ${months === m ? "is-active" : ""}`} onClick={() => setMonths(m)}>
                {m} {m === 1 ? "mes" : "meses"}
              </button>
            ))}
          </div>
          <small>{fmtMoney(monthly)} MXN/mes · {client.subscription?.seats ?? 1} asiento{(client.subscription?.seats ?? 1) === 1 ? "" : "s"}</small>
        </div>
        <label className="sa-field">
          <span>Referencia / folio SPEI (opcional)</span>
          <input value={reference} onChange={(e) => setReference(e.target.value)} placeholder="Ej: folio SPEI" inputMode="text" autoCapitalize="characters" />
        </label>
        <label className="sa-field">
          <span>Vigencia hasta (opcional)</span>
          <input type="date" value={expiresAt} onChange={(e) => setExpiresAt(e.target.value)} />
          <small>{expiresAt ? "La vigencia quedará exactamente en esa fecha y se ignoran los meses." : "Extiende desde la fecha vigente (o desde hoy si ya venció) y reactiva la suscripción."}</small>
        </label>
      </div>
    </Sheet>
  );
}
